import {
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonPage,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { cubeOutline, hammerOutline, openOutline } from "ionicons/icons";
import React, { useState } from "react";
import BlockFeed from "../components/blockfeed/BlockFeed";
import QuikStrike from "../platforms/cmed/QuikStrike/QuikStrike";
import { Browser } from "@capacitor/browser";
import QSIcon from "../theme/custom-icons/QS.svg";
import { CMEDfirebaseLogEvent } from "../utils/firebaseAnalytics/firebaseUtils";
import firebaseEventConfig from "../utils/firebaseAnalytics/firebaseEventConfig";

/**
 * @author
 * E45597 Aryamitra Chaudhuri
 */

interface MorePageProps {
  currentSelectedProfile?: number | undefined;
}

const insightsLinks = [
  {
    title: "Economic Research",
    link: "https://www.cmegroup.com/insights/economic-research.html",
  },
  {
    title: "Market Commentary Videos",
    link: "https://www.cmegroup.com/videos.html#filters=market-commentary",
  },
  {
    title: "Product Analysis and Commentary",
    link: "https://www.cmegroup.com/insights/product-analysis-and-commentary.html",
  },
  {
    title: "Off The Charts Podcast Series",
    link: "https://www.cmegroup.com/podcasts/off-the-charts-podcast-series.html",
  },
];

const openCapacitorSite = async (link: any) => {
  await Browser.open({ url: link });
};

const MorePage: React.FC<MorePageProps> = ({ currentSelectedProfile }) => {
  const [isBlockFeedOpen, setIsBlockFeedOpen] = useState<boolean>(false);
  const [isQuikStrikeOpen, setIsQuikStrikeOpen] = useState<boolean>(false);
  return (
    <React.Fragment>
      <IonPage>
        <IonHeader className="ion-no-border">
          <IonToolbar>
            <IonTitle></IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonList inset={true}>
            <p className="ion-padding ion-no-margin">MARKETS</p>
            <IonItem
              button
              detail={true}
              lines="none"
              color="light"
              onClick={() => {
                setIsBlockFeedOpen(true);
                CMEDfirebaseLogEvent(
                  firebaseEventConfig.CMEDComponentNames.CMED_BLOCK_FEED,
                  firebaseEventConfig.eventNames.CMED_BLOCK_FEED
                    .CMED_BLOCK_FEED_VIEW_WINDOW,
                );
              }}
            >
              <IonIcon icon={cubeOutline} slot="start"></IonIcon>
              <IonLabel>Block Trades</IonLabel>
            </IonItem>
          </IonList>
          <IonList inset={true}>
            <p className="ion-padding ion-no-margin">TOOLS</p>
            <IonItem
              button
              detail={true}
              lines="none"
              color="light"
              onClick={() => {
                setIsQuikStrikeOpen(true);
                CMEDfirebaseLogEvent(
                  firebaseEventConfig.CMEDComponentNames.CMED_QUIKSTRIKE,
                  firebaseEventConfig.eventNames.CMED_QUIKSTRIKE
                    .CMED_QUIKSTRIKE_VIEW_WINDOW,
                );
              }}
            >
              <IonIcon icon={QSIcon} slot="start" size="small"></IonIcon>
              <IonLabel>QuikStrike</IonLabel>
            </IonItem>
          </IonList>
          <IonList inset={true}>
            <p className="ion-padding ion-no-margin">INSIGHTS</p>
            {insightsLinks?.map((elem: any, index: any) => (
              <IonItem
                key={index}
                button
                detail={true}
                detailIcon={openOutline}
                color="light"
                onClick={() => openCapacitorSite(elem?.link)}
              >
                <IonLabel>{elem?.title}</IonLabel>
              </IonItem>
            ))}
          </IonList>
        </IonContent>
        <BlockFeed
          isUserSettingsModalOpen={false}
          isBlockFeedOpen={isBlockFeedOpen}
          setIsBlockFeedOpen={setIsBlockFeedOpen}
          currentSelectedProfile={currentSelectedProfile}
        />
        <QuikStrike
          isQuikStrikeOpen={isQuikStrikeOpen}
          setIsQuikStrikeOpen={setIsQuikStrikeOpen}
        />
      </IonPage>
    </React.Fragment>
  );
};

export default MorePage;
